import { combineReducers } from 'redux';
import ticketAccessToken from './ticketAccessToken';
import  accessToken  from "./getAccessToken";


export default combineReducers({
  TicketAccessToken:ticketAccessToken,
  AccessToken:accessToken,
});
